export const customObjectsUserRelationshipTypeAttributes = "/custom_objects/user_relationship_type_attributes";
